import PropTypes from "prop-types"


const properties = {
  secretCode: PropTypes.string,
  setupUri: PropTypes.string
}

const StartTotpSetupOutputShapeShape = PropTypes.exact(properties)

export default StartTotpSetupOutputShapeShape
export { properties }
